import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/Home.vue";
import Applied from "../components/Applied.vue";
import ProjectDetail from "../components/ProjectDetail.vue";
import AppliedProjectDetail from "../components/AppliedProjectDetail.vue";
import FAQ from "../components/FAQ.vue";
import Document from "../components/Document.vue";
import Mypage from "../components/MyPage.vue";
import SignUp from "../components/SignUp.vue";
import SnsAccounts from "../components/SnsAccounts.vue";
import Terms from "../components/Terms.vue";
import RegistModal from "../components/RegistModal.vue";
import Bank from "../components/Bank.vue";
// import PreRegistration from "../components/PreRegistration.vue";
import AccountDetail from "../components/AccountDetail.vue";
import Withdrawal from "../components/Withdrawal.vue";
import UploadFile from "../components/UploadFile.vue";
import BankDetail from "../components/BankDetail.vue";
import Draft from "../components/Draft.vue";
import PreviewDraft from "../components/PreviewDraft.vue";
import Address from "../components/Address.vue";
import AddressDetail from "../components/AddressDetail.vue";
import UserPaymentTransfers from "../components/UserPaymentTransfers.vue";

const routes = [
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { title: "OMOT Influencer" },
  },
  {
    path: "",
    name: "home",
    component: Home,
    meta: { title: "OMOT Influencer" },
  },
  {
    path: "/regist-modal",
    name: "regist-modal",
    component: RegistModal,
    meta: { title: "OMOT Influencer RegistModal" },
  },
  {
    path: "/bank",
    name: "bank",
    component: Bank,
    meta: { title: "" },
  },
  {
    path: "/bank-detail",
    name: "bank-detail",
    component: BankDetail,
    meta: { title: "振込先銀行口座情報" },
  },
  {
    path: "/applied",
    name: "applied",
    component: Applied,
    meta: { title: "Applied" },
  },
  {
    path: "/project-detail",
    name: "project-detail",
    component: ProjectDetail,
    meta: { title: " " },
  },
  {
    path: "/applied-project-detail",
    name: "applied-project-detail",
    component: AppliedProjectDetail,
    meta: { title: " " },
  },
  {
    path: "/sns-accounts",
    name: "sns-accounts",
    component: SnsAccounts,
    meta: { title: "SNSアカウント登録" },
  },
  {
    path: "/terms-of-use",
    name: "terms-of-use",
    component: Terms,
    meta: { title: "利用規約" },
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ,
    meta: { title: "FAQ・お問い合わせ" },
  },
  {
    path: "/documents",
    name: "documents",
    component: Document,
    meta: { title: "三条書面一覧" },
  },
  {
    path: "/mypage",
    name: "mypage",
    component: Mypage,
    meta: { title: "マイページ" },
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: SignUp,
    meta: { title: "新規登録" },
  },
  {
    path: "/account-detail",
    name: "account-detail",
    component: AccountDetail,
    meta: { title: "ユーザー情報" },
  },
  {
    path: "/Withdrawal",
    name: "withdrawal",
    component: Withdrawal,
    meta: { title: "ユーザー削除" },
  },
  {
    path: "/upload-file",
    name: "upload-file",
    component: UploadFile,
    meta: { title: "" },
  },
  {
    path: "/draft",
    name: "draft",
    component: Draft,
    meta: { title: "" },
  },
  {
    path: "/preview-draft",
    name: "preview-draft",
    component: PreviewDraft,
    meta: { title: "下書きプレビュー" },
  },
  {
    path: "/address",
    name: "address",
    component: Address,
    meta: { title: "" },
  },
  {
    path: "/address-detail",
    name: "address-detail",
    component: AddressDetail,
    meta: { title: "配送先住所情報" },
  },
  {
    path: "/user-payment-transfers",
    name: "user-payment-transfers",
    component: UserPaymentTransfers,
    meta: { title: "支払い通知書一覧" },
  },
  // line messageからの遷移（案件詳細）
  {
    path: "/?projectDetailId=:id",
    name: "project-detail-id",
    component: Home,
    meta: { title: "案件詳細" },
  },
  // line messageからの遷移（応募案件）
  {
    path: "/?projectId=:id",
    name: "project-id",
    component: Home,
    meta: { title: "応募案件詳細" },
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "from-line-message",
  //   component: Home,
  //   meta: { title: "" },
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const DEFAULT_TITLE = "OMI";
// コンポーネントごとにtitleタグを変える
router.afterEach((to) => {
  document.title = String(to.meta.title) || DEFAULT_TITLE;
});

export default router;
